import React, { FC, useCallback, useState } from 'react'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { TextButton } from 'components/Button'
import { Spacer } from 'components/Utility'
import { DeliveryScheduleCollectiveConfirmCard } from 'components/Card'
import { ConfirmStock, StockType } from 'types/stock'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'
import { getBreadShortName } from 'lib/helper'

type Props = {
  confirmStocks: ConfirmStock[]
  storeDeliveryBreads: StoreDeliveryBreadType[]
}

const DeliveryScheduleCollectiveConfirmCardList: FC<Props> = (props) => {
  const { confirmStocks, storeDeliveryBreads } = props

  const [expandStatus, setIsExpandedAll] = useState<string>('expanded')

  const expandAllAccordion = useCallback(() => setIsExpandedAll('expanded'), [setIsExpandedAll])
  const foldAllAccordion = useCallback(() => setIsExpandedAll('folded'), [setIsExpandedAll])
  const resetExpandedStatus = useCallback(() => setIsExpandedAll(''), [setIsExpandedAll])

  return (
    <>
      <p className={text.font_bold}>{confirmStocks.length}件の商品を表示中</p>
      <Spacer size={12} />
      <FlexRow justifyContent={'start'}>
        <TextButton
          disabled={expandStatus === 'expanded'}
          iconPath={expandStatus === 'expanded' ? '/icon/grey/plus.svg' : '/icon/blue/plus.svg'}
          label={'すべて開く'}
          onClick={expandAllAccordion}
        />
        <Spacer size={32} axis={'horizontal'} />
        <TextButton
          disabled={expandStatus === 'folded'}
          iconPath={expandStatus === 'folded' ? '/icon/grey/minus.svg' : '/icon/blue/minus.svg'}
          label={'すべてたたむ'}
          onClick={foldAllAccordion}
        />
      </FlexRow>
      <Spacer size={12} />
      {confirmStocks.map((confirmStock, index) => {
        const { addedStocks, bread, deletedStocks, updatedStocks } = confirmStock
        if (!bread.bread_ref) return

        // 重複している日付を除外
        const _addedStocks = addedStocks.reduce((prev, stock) => {
          if (prev.every((_stock) => _stock.date !== stock.date)) {
            return [...prev, stock]
          } else {
            return [...prev]
          }
        }, [] as StockType[])

        // 受渡解禁時刻の上書きに伴うIDが違うdeletedStocksは除外
        const _deletedStocks = deletedStocks
          .filter((deletedStock) => updatedStocks.every((updatedStock) => updatedStock.date !== deletedStock.date))
          .reduce((prev, stock) => {
            if (prev.every((_stock) => _stock.date !== stock.date)) {
              return [...prev, stock]
            } else {
              return [...prev]
            }
          }, [] as StockType[])

        const storeDeliveryBread = storeDeliveryBreads.find(
          (storeDeliveryBread) => storeDeliveryBread.bread_ref?.id === bread.bread_ref?.id
        )
        if (!storeDeliveryBread) return

        return (
          <React.Fragment key={bread.bread_ref.id}>
            {index !== 0 && <Spacer size={8} />}
            <DeliveryScheduleCollectiveConfirmCard
              addedStocks={_addedStocks}
              breadName={getBreadShortName(bread)}
              deletedStocks={_deletedStocks}
              expandStatus={expandStatus}
              imageUrl={bread.image_urls[0] || ''}
              resetExpandedStatus={resetExpandedStatus}
              storeDeliveryBread={storeDeliveryBread}
            />
          </React.Fragment>
        )
      })}
    </>
  )
}

export default DeliveryScheduleCollectiveConfirmCardList
